<template>
<div class="page page_order page_settle page_tui">
    <!-- 商品信息 -->
    <div class="list">
        <div class="item">
            <div class="item_nr">
                <div class="item_nr_l">
                    <img :src="thumb" alt="" class="tu" />
                </div>
                <div class="item_nr_r">
                    <div class="item_nr_r_t">
                        <div class="title slh">
                            {{ title }}
                        </div>
                        <div class="info">
                            <span class="price"><span class="tag_cash">¥</span>{{ price }}</span>
                            <span class="nums">x{{ count }}</span>
                        </div>
                    </div>
                    <div class="sku">{{ spec }}</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 状态 -->
    <div class="item status" v-if="status != -1">
        <div class="status_l">
            <div class="status_l_t">
                <div class="status_title">状态</div>
                <!-- <div class="status_time">剩余处理时间 0天22时42分03秒</div> -->
            </div>
            <div class="status_m">{{ statusText }}</div>
            <div class="status_b" v-if="status == 0">商家超过24小时未处理，平台将介入处理</div>
        </div>
        <div class="status_r" v-if="status != 1 && status != 11" @click="cancelAfterSale">取消售后</div>
    </div>
    <!-- 类型 -->
    <div class="item item_tui">
        <div class="item_l">类型</div>
        <div class="item_r" @click="onSelectType">{{ currentType ? currentType.name : "请选择" }}</div>
    </div>
    <!-- 退款金额 -->
    <div class="item item_tui">
        <div class="item_l">退款金额</div>
        <div class="item_r noarrow">
			<!-- 2023年1月30日 退款金额 由 :readonly="status == -1 ? false : true" 改为不可编辑 -->
            <van-field v-model="return_price" placeholder="请输入金额" :readonly="true" @blur="getInputVal" />
        </div>
    </div>
    <!-- 问题说明 -->
    <div class="item item_shuoming">
        <div class="item_l">退款原因</div>
        <div class="item_r">
            <van-field type="textarea" maxlength="200" :show-word-limit="true" v-model="reason" placeholder="请输入退款原因" :readonly="status == -1 ? false : true" />
        </div>
    </div>
    <!-- 上传凭证 -->
    <div class="pingzheng">
        <div class="title">上传凭证</div>
        <div class="nr">
            <div class="upload-images" v-if="status == -1">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po" @click="datuFun(index)">
                        <van-image
							width="2.04rem"
							height="2.04rem"
							fit="contain"
							:src="imageUrl+item"
						/>
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add">
                    <div class="addPhone">添加照片</div>
                </van-uploader>
            </div>
            <div class="upload-images" v-else>
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po" @click="datuFun(index)">
						<van-image
							width="2.04rem"
							height="2.04rem"
							fit="contain"
							:src="imageUrl+item"
						/>
                        <!-- <img class="image" :src="imageUrl+item" /> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 快递 单号 -->
    <div class="" v-if="status == 4 || status == 12">
        <div class="item item_tui">
            <div class="item_l">退货快递</div>
            <div class="item_r noarrow">
                <van-field v-model="return_logistics_name" placeholder="请输入快递名称" />
            </div>
        </div>
        <div class="item item_tui">
            <div class="item_l">快递单号</div>
            <div class="item_r noarrow">
                <van-field v-model="return_logistics_code" placeholder="请输入快递单号" />
            </div>
        </div>
    </div>
	<!-- 显示已提交过的快递单号 -->
	<div class="" v-if="return_type == 2 && user_logistics_name && user_logistics_code">
        <div class="item item_tui">
            <div class="item_l">退货快递</div>
            <div class="item_r noarrow">{{ user_logistics_name }}</div>
        </div>
        <div class="item item_tui">
            <div class="item_l">快递单号</div>
            <div class="item_r noarrow">{{ user_logistics_code }}</div>
        </div>
    </div>
    <!-- 提交 -->
    <div class="bottom" v-if="status == -1 || status == 4 || status == 12">
        <div class="bottom_action" @click="clickReturn">提交</div>
    </div>
    <!-- 申诉 -->
    <div class="bottom" v-if="status == 7">
        <div class="bottom_action" @click="clickShensu">我要申诉</div>
    </div>
    <!-- 类型 -->
    <van-popup v-model="showTypePicker" round position="bottom">
        <van-picker show-toolbar value-key="name" :columns="typeList" @cancel="showTypePicker = false" @confirm="onConfirmType" />
    </van-popup>
    <!-- 展示大图 -->
    <van-image-preview v-model="showDatu" :start-position="currentIndex" :images="previewImages" @change="onChangeImage">
    </van-image-preview>
	<!-- 遮罩层 加载 -->
	<van-overlay class="custom-overlay" :show="showLoading">
		<van-loading />
	</van-overlay>
</div>
</template>

<script>
import Vue from "vue";
import router from "../../../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../../../.././vuex/mutation_types";
import Bridge from "../../../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    data() {
        return {
			showLoading: false, // 遮罩加载
			showDatu: false,
			currentIndex: 0,
			previewImages: [],
            shipStatus: this.$route.query.shipStatus, // 发货状态 0 1
            returnId: this.$route.query.returnId,
            publicPath: process.env.BASE_URL,
            orderId: this.$route.query.orderId,
            thumb: '',
            title: '',
            price: '', // 单价
            count: '',
            spec: '',
            imageUrl: this.$publicData.uploadImage,
            reason: "",
            token: '',
            imglist: [], // 上传回显图片列表
            showTypePicker: false,
            typeList: [{
                    id: 1,
                    name: "仅退款"
                },
                {
                    id: 2,
                    name: "退货退款"
                }
            ], // 退款类型
            currentType: null,
            return_price: "", // 退款金额
            total_prices: "", // 总价
            return_logistics_code: "", // 快递单号
            return_logistics_name: "", // 快递名称
            status: -1, // 共13种退款状态(-1除外,-1是未申请)
            statusText: "", // 退款文字描述
			return_type: null,
			user_logistics_name: "", // 用户提交的快递信息
			user_logistics_code: "" // 用户提交的快递信息
        };
    },
    created: function () {
        if (this.shipStatus == 0) {
            this.typeList.splice(1, 1);
        }
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '申请退换',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token;
					this.getOrderGoodsInfo();
                    if (this.returnId && this.returnId != 0) {
                        this.getData()
                    }
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                if (this.returnId && this.returnId != 0) {
                    this.getData()
                }
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token;
			this.getOrderGoodsInfo();
            // 退货订单详情
            if (this.returnId && this.returnId != 0) {
                this.getData()
            }
        }
    },
    methods: {
		// 商品订单详情
		getOrderGoodsInfo(){
			let params = {
				token: this.token,
				order_good_id: this.orderId
			};
			this.$api.shop.goodorderinfo(params).then(res=>{
				if(res.code == 200){
					let thumb = res.result.thumb;
					this.thumb = thumb ? this.imageUrl+thumb : this.$publicData.intangibleDefault;
					this.title = res.result.title;
					this.price = res.result.price;
					this.count = res.result.num;
					this.spec = res.result.spec_name;
					this.total_prices = res.result.total_prices;
					this.return_price = res.result.total_prices;
				}else{
					this.$toast(res.message)
				}
			})
		},
        // 退货订单详情
        getData() {
            let params = {
                token: this.token,
                return_id: this.returnId
            };
            this.$api.shop.returndetail(params).then(res => {
				this.showLoading = false;
                if (res.code == 200) {
                    let info = res.result;
					this.return_type = info.return_type;
					this.user_logistics_name = info.return_logistics_name;
					this.user_logistics_code = info.return_logistics_code;
                    let status = info.status; // 共13种状态 info.status
                    let statusText = "";
                    if (status == 0) {
                        statusText = "商家受理中";
                    } else if (status == 1) {
                        statusText = "退款成功";
                    } else if (status == 2) {
                        statusText = "平台拒绝用户售后";
                    } else if (status == 3) {
                        statusText = "商家同意退款,退款中";
                    } else if (status == 4) {
                        statusText = "商家同意退款,请寄回商品";
                    } else if (status == 5) {
                        statusText = "待商家收货";
                    } else if (status == 6) {
                        statusText = "商家确认收货,退款中";
                    } else if (status == 7) {
                        statusText = "商家拒绝退款";
                    } else if (status == 8) {
                        statusText = "平台介入中";
                    } else if (status == 9) {
                        statusText = "平台同意退款,退款中";
                    } else if (status == 10) {
                        statusText = "退款失败";
                    } else if (status == 11) {
                        statusText = "用户取消售后";
                    } else if (status == 12) {
                        statusText = "平台同意退款,请寄回商品";
                    }
                    this.status = status;
                    this.statusText = statusText;
                    this.return_price = info.total_prices;
                    this.reason = info.mark;
                    // 图片列表
                    if (info.thumb) {
                        this.imglist = info.thumb.split(",").filter(item => item != "");
                    };
                    // 当前退款类型
                    for (let i in this.typeList) {
                        if (info.return_type == this.typeList[i].id) {
                            this.currentType = this.typeList[i];
                            break;
                        }
                    }
                }
            })
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        },
        // 图片上传
        onRead: function (file) {
            // console.log("file");
            // console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            // console.log("上传成功");
                            // console.log(res);
                            var url = res.result.url
                            this.imglist.push(url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        // console.log("上传成功");
                        // console.log(res);
                        var url = res.result.url
                        this.imglist.push(url);
                    }
                });
            }
            // console.log("上传的图片列表");
            // console.log(this.imglist);
        },
        clickReturn() {
            let that = this;
            if (this.status == -1) {
                // 申请退款
                if (this.currentType == null) {
                    this.$toast('请选择退款类型')
                    return
                }
                if (!this.return_price) {
                    this.$toast('请输入退款金额')
                    return
                }
				if(!this.reason){
					this.$toast('请输入退款原因')
                    return
				}
				this.showLoading = true;
                let params = {
                    token: this.token,
                    ordergood_id: this.orderId,
                    return_price: this.return_price,
                    return_type: this.currentType.id,
					mark: this.reason
                }
                if (this.imglist.length != 0) {
                    let img = '';
                    for (let i = 0; i < this.imglist.length; i++) {
                        const image = this.imglist[i];
                        if (img != '') {
                            img += ','
                        }
                        img += image
                    };
                    params.thumb = img;
                };
                this.$api.shop.ordernewreturn(params).then(res => {					
                    if (res.code == 200) {
                        this.$toast(res.message)
                        setTimeout(() => {	
                            that.$router.back();
                        }, 200);
                    } else {
                        this.$toast(res.message);
						this.showLoading = false;
                    }
                })
            } else if (this.status == 4 || this.status == 12) {
                // 回寄商品
                if (!this.return_logistics_name || !this.return_logistics_code) {
                    this.$toast("请完善快递信息");
                    return;
                } else {
					this.showLoading = true;
                    let params = {
                        token: this.token,
                        return_id: this.returnId,
                        return_logistics_code: this.return_logistics_code,
                        return_logistics_name: this.return_logistics_name
                    }
                    this.$api.shop.returnlogistics(params).then(res => {
                        if (res.code == 200) {
                            this.$toast(res.message)
                            setTimeout(() => {
                                that.getData();
                            }, 2000);
                        }else{							
							this.showLoading = false;
							this.$toast(res.message);
						}
                    })
                }
            }
        },
        onSelectType() {
            if (this.status == -1) {
                this.showTypePicker = true;
            }
        },
        onConfirmType(val, index) {
            this.currentType = val;
            this.showTypePicker = false;
        },
        // 获取输入的金额值
        getInputVal() {
            if (parseFloat(this.return_price) > this.total_prices) {
                this.$toast("退款金额不得高于总价");
                this.return_price = this.total_prices;
            }
        },
        // 申诉
        clickShensu() {
			this.showLoading = true;
            let params = {
                token: this.token,
                return_id: this.returnId
            }
            this.$api.shop.shensureturn(params).then(res => {	
                if (res.code == 200) {
                    this.$toast(res.message)
                    setTimeout(() => {
                        this.getData();
                    }, 2000);
                }else{
					this.showLoading = false;
					this.$toast(res.message)
				}
            })
        },
        // 取消售后
        cancelAfterSale() {
            let params = {
                token: this.token,
                return_id: this.returnId
            }
            this.$api.shop.quxiaoreturn(params).then(res => {
                if (res.code == 200) {
                    this.$toast(res.message)
                    setTimeout(() => {
                        this.getData();
                    }, 2000);
                }
            })
        },
		// 点击查看大图
		datuFun(index){
			this.showDatu = true;
			this.currentIndex = index;
			let arr = [];
			for(let i in this.imglist){
				arr.push(this.imageUrl+this.imglist[i])
			};
			this.previewImages = arr;
		},
		// 切换大图
		onChangeImage(index){
			this.currentIndex = index;
		}
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page_tui {
    padding-bottom: 2rem;
}

.page_tui .item_tui .item_l {
    min-width: 1.8rem;
}

.page_tui .item_tui .item_r {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
}

.page_tui .item_shuoming {
    height: auto;
    padding: .32rem 0.53rem;
    align-items: flex-start;
}

.page_tui .item_tui .item_r.noarrow::after {
    display: none;
}

.page_tui .item.status {
    padding: .32rem .53rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.page_tui .item.status .status_r {
    width: 2rem;
    height: 0.67rem;
    text-align: center;
    line-height: 0.67rem;
    border-radius: 0.33rem;
    border: 0.0134rem solid rgba(211, 68, 68, 1);
    color: rgba(211, 68, 68, 1);
}

.page_tui .status_l_t {
    display: flex;
    align-items: center;
}

.page_tui .status_time {
    color: #cccccc;
    padding-left: .6rem;
}

.page_tui .status_m {
    font-size: .6rem;
    color: #14d647;
}

.page_tui .status_b {
    color: #cccccc;
}

.page_tui .pingzheng {
    padding-bottom: .4rem;
}

.page_tui .bottom {
    position: fixed;
    bottom: 0rem;
    width: 100%;
    background: #ffffff;
    padding-bottom: 0.4rem;
    padding-top: 0.4rem;
}
.page_tui .icon-po .van-image img{
	border-radius: .13rem;
}
.custom-overlay .van-loading{
	position: absolute;
	top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
</style>
